import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Building2, ChevronRight } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';
import { useT } from '../i18n';
import { Brand } from '../app/Brand';
import { Card } from '../ui';
import { LoginControls } from './LoginControls';
import { useAuthStore, useIsAuthenticated } from './store';
import s from './SelectOrgPage.module.css';

/** Choix de l'organisation après connexion (compte rattaché à plusieurs organisations). */
export function SelectOrgPage() {
  const { t } = useT();
  const authed = useIsAuthenticated();
  const user = useAuthStore((x) => x.user);
  const setOrgId = useAuthStore((x) => x.setOrgId);
  const navigate = useNavigate();
  const location = useLocation();
  const qc = useQueryClient();
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  if (!authed || !user) return <Navigate to="/login" replace />;

  return (
    <div className={s.page}>
      <header className={s.top}>
        <Brand />
        <div className={s.controls}>
          <LoginControls />
        </div>
      </header>
      <main className={s.main}>
        <h1>{t('selectOrg.title')}</h1>
        <p>{t('selectOrg.subtitle', { name: user.name })}</p>
        <ul className={s.list}>
          {user.memberships.map((m) => (
            <li key={m.orgId}>
              <Card as="article" padding="none">
                <button
                  type="button"
                  className={s.item}
                  onClick={() => {
                    qc.removeQueries({ queryKey: ['org'] });
                    setOrgId(m.orgId);
                    navigate(from, { replace: true });
                  }}
                >
                  <span className={s.icon}>
                    <Building2 size={22} />
                  </span>
                  <span className={s.text}>
                    <strong>{m.orgName}</strong>
                    <span>{m.roleName}</span>
                  </span>
                  <ChevronRight size={20} className="flip-rtl" aria-hidden="true" />
                </button>
              </Card>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}
